import { TableCell as MaterialTableCell } from '@mui/material';

import type { Column, PinnedCellLayout } from 'ui/organisms';
import { Tooltip } from '../Tooltip/tooltip.atom';

interface Row<T> {
  id: string;
  data: T;
  disabled?: boolean;
  disabledTooltip?: string;
}

interface Props<T> {
  row: Row<T>;
  column: Column<T>;
  handleClick: (event: React.MouseEvent<unknown>, id: string, data: T) => void;
  index: number;
  isLastItem: boolean;
  dataCy?: string;
  pinned?: PinnedCellLayout;
}

export const TableCell = <T,>(props: Props<T>) => {
  return (
    <MaterialTableCell
      align={props.column.align}
      key={`${String(props.column.id)})-${props.index}`}
      onClick={(event) => props.handleClick(event, props.row.id, props.row.data)}
      className={props.pinned ? 'gcv-table-cell--pinned' : undefined}
      sx={{
        padding: props.column.disablePadding ? '0' : '9px 18px',
        width: props.column.widthPercent ? `${props.column.widthPercent}%` : null,
        minWidth: props.column.minWidth ? `${props.column.minWidth}px` : null,
        borderBottom: (theme) => (props.isLastItem ? 'none' : `0.016rem solid ${theme.palette.divider}`),
        lineHeight: '18.2px',
        fontSize: '13px',
        wordWrap: 'break-word',
        ...(props.pinned && {
          position: 'sticky',
          left: `${props.pinned.left}px`,
          zIndex: 3,
          boxShadow: props.pinned.isLast ? '2px 0 6px rgba(36, 40, 52, 0.06)' : undefined,
          // Pinned cells fix at minWidth so sticky offsets stay deterministic.
          ...(props.column.minWidth && {
            width: `${props.column.minWidth}px`,
            maxWidth: `${props.column.minWidth}px`
          })
        })
      }}
      data-cy="table-cell"
    >
      <Tooltip
        placement={'top'}
        title={props.row.disabledTooltip || ''}
        disabled={!props.row.disabled || props.column.disableRowTooltip}
        display="block"
      >
        <>{props.column.format ? props.column.format(props.row.data) : props.row.data[props.column.id]}</>
      </Tooltip>
    </MaterialTableCell>
  );
};
